export const PRODUCTS = [
  {
    id: "carpool",
    name: "CarPooling App",
    shortDescription: "A smart ride-sharing app that helps drivers and passengers share rides, save money, and travel efficiently.",
    longDescription: "A smart ride-sharing app that helps drivers and passengers share rides, save money, and travel efficiently. Find or offer rides instantly, track trips in real-time, chat in-app, and enjoy secure OTP-verified bookings.",
    features: [
      "Real-time ride search",
      "Offer or book rides",
      "GPS tracking & chat",
      "Scheduled & recurring rides",
      "Safety: OTP + verified profiles"
    ],
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&h=600&fit=crop&q=80"
  },
  {
    id: "school-management",
    name: "AJWS-School App",
    shortDescription: "A smart school management app connecting parents, teachers, and students in one place.",
    longDescription: "AJWS-School is a smart school management app connecting parents, teachers, and students in one place. Track homework, check attendance, manage leave requests, view timetables, receive announcements, and communicate instantly. Exclusive to AJWS school members.",
    features: [
      "Homework & attendance tracking",
      "Parent–teacher messaging",
      "Leave requests & announcements",
      "Timetable + multi-child support"
    ],
    image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&h=600&fit=crop&q=80"
  },
  {
    id: "restaurant-management",
    name: "Restaurant Management",
    shortDescription: "POS, KDS, reservations, inventory and analytics for restaurants.",
    longDescription: "A cloud-first restaurant management suite combining POS, kitchen display, reservations, inventory tracking and analytics. Scales from single-location restaurants to multi-outlet chains.",
    features: [
      "Cloud POS & KDS",
      "Reservations & table management",
      "Inventory & low-stock alerts",
      "Sales analytics",
      "AI menu recommendations"
    ],
    image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&h=600&fit=crop&q=80"
  },
  {
    id: "hotel-management",
    name: "Hotel Management",
    shortDescription: "PMS with reservations, housekeeping, billing and channel sync.",
    longDescription: "Property Management System designed for hotels and guesthouses, with reservations, billing, housekeeping coordination, and channel manager integration for OTAs.",
    features: [
      "Reservation & rate management",
      "Housekeeping coordination",
      "Billing & invoicing",
      "Channel manager integration",
      "Guest self-service portal"
    ],
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=600&fit=crop&q=80"
  },
  {
    id: "field-sales",
    name: "Sales",
    shortDescription: "A field-force app for sales teams to manage visits, customers, expenses, and attendance from anywhere.",
    longDescription: "Sales is a field-force app for sales teams to manage visits, customers, expenses, and attendance from anywhere. Plan routes, log visits, submit expenses, track performance, and work offline when needed.",
    features: [
      "Customer & visit management",
      "GPS check-in/out",
      "Expenses & attendance",
      "Tasks, requirements & complaints",
      "Offline mode + real-time sync"
    ],
    image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800&h=600&fit=crop&q=80"
  },
  {
    id: "document-management",
    name: "Document Management System",
    shortDescription: "Secure DMS with OCR, workflows and version control.",
    longDescription: "A secure DMS offering OCR, classification, versioning, role-based access, search and automated approval workflows designed for compliance-focused teams.",
    features: [
      "OCR & metadata extraction",
      "Full-text search",
      "Version control & audit logs",
      "Role-based access",
      "Automated approval workflows"
    ],
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&h=600&fit=crop&q=80"
  }
];

export const SOLUTIONS = [
  {
    id: "education",
    title: "Education",
    problem: "Fragmented student data and disconnected parent communication.",
    valueProp: "Unified school automation that keeps parents, teachers, and admins in sync.",
    benefits: [
      "Automated attendance tracking",
      "Real-time parent portals",
      "Seamless grading & report cards"
    ],
    icon: "GraduationCap"
  },
  {
    id: "mobility",
    title: "Mobility & Fleet",
    problem: "Inefficient routing and lack of real-time fleet visibility.",
    valueProp: "AI-driven dispatch and routing to maximize fleet utilization.",
    benefits: [
      "Dynamic route optimization",
      "Real-time driver matching",
      "Fleet admin dashboards"
    ],
    icon: "Car"
  },
  {
    id: "hospitality",
    title: "Hospitality",
    problem: "Complex reservation management across multiple channels.",
    valueProp: "Integrated PMS and POS that streamlines guest experiences.",
    benefits: [
      "Centralized reservations",
      "Housekeeping workflow automation",
      "Channel manager sync"
    ],
    icon: "Hotel"
  },
  {
    id: "retail",
    title: "Retail & Restaurants",
    problem: "Inventory mismatch and slow checkout processes.",
    valueProp: "Cloud POS with predictive inventory management.",
    benefits: [
      "Fast checkout POS",
      "AI demand forecasting",
      "Low-stock alerts"
    ],
    icon: "ShoppingBag"
  },
  {
    id: "field-sales",
    title: "Field Sales Ops",
    problem: "Lost time on the road and delayed order processing.",
    valueProp: "Mobile-first tools for field teams to sell more and travel less.",
    benefits: [
      "Optimized visit planning",
      "Offline order capture",
      "Productivity tracking"
    ],
    icon: "Map"
  },
  {
    id: "enterprise-dms",
    title: "Enterprise Workflows",
    problem: "Manual data entry and unorganized document storage.",
    valueProp: "Intelligent document processing with OCR and compliance workflows.",
    benefits: [
      "OCR text extraction",
      "Automated classification",
      "Approval workflows"
    ],
    icon: "FileText"
  }
];

export const NAV_LINKS = [
  { name: 'Home', path: '/' },
  { name: 'Products', path: '/products' },
  { name: 'About', path: '/about' },
];

